export default __webpack_public_path__ + "static/media/ticket.5799f40e.svg";